/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForSaasOtherServices extends models.ServiceAccountNativeDetailsForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForSaasOtherServices");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForSaasOtherServices.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForSaasOtherServices>): ServiceAccountNativeDetailsBaseForSaasOtherServices {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForSaasOtherServices(), model);
        ServiceAccountNativeDetailsBaseForSaasOtherServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForSaasOtherServices>): ServiceAccountNativeDetailsBaseForSaasOtherServices {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForSaasOtherServices.newInstance(<ServiceAccountNativeDetailsBaseForSaasOtherServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForSaasOtherServices) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForSaasOtherServices): boolean {
        if (models.ServiceAccountNativeDetailsForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForSaasOtherServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
